<!-- <div id="leyenda">
    <div *ngIf="tareasFitosanitarias" class="wrapper"><div class="square red"></div>Tareas Fito</div>
    <div *ngIf="tareasBio" class="wrapper"><div class="square blue"></div>Tareas Bio</div>
    <div *ngIf="tareasFertilizantes" class="wrapper"><div class="square orange"></div>Tareas Ferti</div>
    <div *ngIf="tareasSiembra" class="wrapper"><div class="square green"></div>Tareas Siembra</div>
    <div *ngIf="tareasGenericas" class="wrapper"><div class="square" style="background-color: #d900ff;"></div>Tareas Genéricas</div>
    <div *ngIf="tareasEventos" class="wrapper"><div class="square bg-dark"></div>Eventos</div>
</div> -->

<div class="container-fluid px-0 calendar-responsive-page">
    <div class="d-flex flex-column flex-sm-row flex-wrap gap-2 align-items-stretch align-items-sm-center mb-3">
        <p class="text-uppercase font-bold bg-white p-2 rounded-2 text-nowrap m-0">Ir a fecha:</p>
        <div class="calendar-filter-control">
            <p-select class="w-100" id="month-dropdown" [options]="months" [formControl]="selectedMonthControl" placeholder="Mes"
            optionLabel="name" optionValue="value" [showClear]="true" (onChange)="showSelectedDate(calendar)"></p-select>
        </div>
        <div class="calendar-filter-control calendar-filter-control-sm">
            <p-select class="w-100" id="year-dropdown" [options]="years" [formControl]="selectedYearControl" placeholder="Año"
            optionLabel="name" optionValue="value" [showClear]="true" (onChange)="showSelectedDate(calendar)"></p-select>
        </div>
        <div *ngIf="this.hasClients && this.appName === 'agrosalvi'" class="calendar-filter-control">
            <p-select class="w-100" id="type-dropdown" [options]="tipos" [formControl]="selectedTipoControl" placeholder="Tipo"
            optionLabel="name" optionValue="value" [showClear]="true" (onChange)="filtrarPorTipoCliente()"></p-select>
        </div>
    </div>

    <div class="row g-3">
        <div class="col-12">
        <full-calendar class="fc-responsive-calendar d-block w-100" #calendar
            [events]="tareasArrayFiltered"
            [deepChangeDetection]="true"
            [options]="options">
        </full-calendar>
        </div>
    </div>
</div>

<p-dialog
        header="Crear tarea"
        [(visible)]="showCreateEventDialog"
        (onShow)="scrollToTop()"
        (onHide)="resetDialog()">

    <div style="width: 80vw !important; min-height: 40vh;">
        @if (showCreateEventDialog && eventForm) {
            <app-reactive-form-builder
                    [form]="eventForm.formFields"
                    [previousData]="model"
                    [request]="eventRequest"
                    [getRequest]="eventGetRequest"
                    [serverUrl]="env.serverUrl"
                    (stableValueChanges)="handleEventFormValueChange($event)"
                    (afterSend)="afterEventSaved()"
                    (goBack)="resetDialog()">
                <button
                        slot="extra-buttons"
                        class="btn btn-danger mx-2 mt-4"
                        type="button"
                        (click)="deleteRegister()"
                        *ngIf="showDeleteButton">
                    <i class="pi pi-trash"></i> Eliminar
                </button>
            </app-reactive-form-builder>
        }
    </div>
    <br>

</p-dialog>